<template>
  <div class="coupon-item-left">
    <div class="coupon-value">
      <div
        class="amount"
        v-if="coupon.coupon_type_id === couponTypeEnum.amount_0"
      >
        <div class="icon">￥</div>
        <div class="price">{{ coupon.cash_reduce / 100 }}</div>
      </div>
      <div
        class="discount"
        v-else-if="coupon.coupon_type_id === couponTypeEnum.discount_1"
      >
        <div class="discount-price">{{ formatDiscount }}</div>
        <div class="icon">折</div>
      </div>
      <div
        class="free"
        v-else-if="coupon.coupon_type_id === couponTypeEnum.free_2"
      >
        <div class="free-price">免{{ coupon.reduce_num }}本</div>
      </div>
    </div>
    <div class="coupon-condition">
      {{ condition }}
    </div>
  </div>
</template>

<script>
import utils from '@/libs/utils';

export default {
  name: 'CouponItemLeft',
  props: {
    coupon: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    condition() {
      if (this.coupon && this.coupon.coupon_type_id === 2) {
        return `满${this.coupon.reach_reduce_num}本可用`;
      } else if (this.coupon.reach_reduce) {
        return `满${this.coupon.reach_reduce / 100}元可用`;
      }
      return '无门槛';
    },
    formatDiscount() {
      return utils.formatNumberWithDecimals(this.coupon.cash_reduce / 1000);
    },
  },
  data() {
    return {
      couponTypeEnum: {
        amount_0: 0,
        discount_1: 1,
        free_2: 2,
      },
    };
  },
};
</script>

<style scoped lang="less">
.coupon-item-left {
  width: 100%;
  height: 100%;
  padding: 10px 2px;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 6px;
  color: #fff;
}
.coupon-value,
.amount,
.discount {
  display: flex;
  justify-content: flex-start;
}
.coupon-condition {
  font-size: 12px;
  color: #fff;
}

.amount {
  .icon {
    font-size: 15px;
    margin: 14px 3px 0 0;
  }
  .price {
    letter-spacing: 0.85px;
    font-size: 34px;
  }
}

.discount {
  display: flex;
  gap: 2px;
  .discount-price {
    font-size: 35px;
  }
  .icon {
    font-size: 14px;
    margin-top: 17px;
  }
}
.free-price {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/activity/coupon-item/coupon-common-item/components/coupon-item-left.vue